import React, { useState } from 'react';
import './functioncard.scss';
import moment from 'moment';
import { useHistory } from 'react-router';
import { Tooltip } from 'antd';
import { FunctionCardTooltip } from './FunctionTooltip';
import { ReactComponent as MoreIcon } from "../../../assets/svg/more.svg";
import { useSelector } from 'react-redux';
import { Http } from '../../../helpers/axois';
import { useToast } from '../../../helpers/commonFunction';
import {GCPENDPOINT} from '../../../constant/common';
import { AppState } from '../../../stateManager/store';
import Placeholder_Icon from "../../../assets/svg/Placeholder_Icon.svg";



export const FunctionCard = ({ functionData, deleteproduct, handleFunctionStatus, editAccess }: any) => {
  const history = useHistory()
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const { SuccessToast, ErrorToast } = useToast();
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const handleClick = (e: { stopPropagation: () => void; }, id: string) => {
    e.stopPropagation();
    history.push(`/marketplace/functions/functionPreview/${id}`)
  };

  const handleFunctionInstall = async (e: { stopPropagation: () => void; }) => {
    e.stopPropagation();
    if ((!orgPermissions?.includes("marketplace.PublishFunc")  || !orgPermissions.includes('org.View'))&& loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Please request owner of this organization to provide access")
      return
    } 
    if (!functionData.is_installed) {
      const endpoint = `/orgs/${orgId}/marketplaceFunctions/install/${functionData.id}`
      try {
        await Http.post(endpoint).toPromise();
        handleFunctionStatus(functionData.id, true)
        SuccessToast(`Installed ${functionData.name}`)
      } catch (err) {
        if (err === "Forbidden") {
          ErrorToast("Not Authorized: Please request owner of this organization to provide access")
        } else {
        // logger.error(err)
        ErrorToast("Failed to install function")
      }
      }
    }
  }

  

  return (
    <div className="function-card-container" >
      <div data-test-id="function_card" className="function-card" role="presentation" onClick={(e) => handleClick(e, functionData.id)}>
        <div className='img-title-desc-container' >
          <div className='image-container' >
            <img
              alt='function-icon' style={{objectFit:"contain"}}
              src={functionData.preview_image ? `${functionData.preview_image?.startsWith("https://") ? functionData.preview_image : GCPENDPOINT+functionData.preview_image}` : Placeholder_Icon}
            />
          </div>
          <div className="info">
            <h4 className="hl truncate text-ellipsis w-90% mr-3.5 pr-3.5 break-all" title={functionData.name}>{functionData.name}</h4>
            {functionData?.description &&
              <p className="truncate-text" style={{ maxHeight: 40 }} title={functionData.description}>{functionData.description}</p>}
          </div>

          <button className="function-more-icon">
            <Tooltip
              className="more"
              onVisibleChange={setTooltipVisible}
              visible={tooltipVisible}
              placement="topLeft"
              overlayClassName="widgetCardTooltip"
              title={
                <FunctionCardTooltip
                  deleteproduct={deleteproduct}
                  functionData={functionData}
                  install={functionData.is_installed}
                  setTooltipVisible={setTooltipVisible}
                  handleFunctionStatus={handleFunctionStatus}
                  editAccess={editAccess}
                />
              }
              trigger="click"
            >
              <MoreIcon height="16px" />
            </Tooltip>
          </button>
        </div>

        <div className="meta-info" style={{ fontSize: "12px" }}>
          <div className="meta-info-publisher">
            <p>
              Published By:{" "}
              <span className="hl">
                {functionData.created_by.first_name}  {functionData.created_by.last_name}
              </span>
            </p>
            <p>
              Last updated:{" "}
              <span className="hl">
                {moment(functionData.updated_at).format("MMM Do YYYY")}
              </span>
            </p>
          </div>
          <div className="version-updated">
            <p style={{ fontSize: "12px" }}>
              Version: <span className="hl">{functionData.version_tag}</span>
            </p>
            <div className="author-install">
              <button
                data-test-id={`${functionData.is_installed ? "Installed" : "Install"}`}
                onClick={handleFunctionInstall}
                className={`${functionData.is_installed ? "btn-installed" : "btn-install"}`}
                style={{ fontSize: "12px", letterSpacing: "0.5px" }}
              >
                {functionData.is_installed ? "Installed" : "Install"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

